import React, { useState } from "react";
import styled from "styled-components";
import { useExtensionContext } from "../ExtensionContext";
import useEtiketEkle from "app/popleads/hooks/useEtiketEkle";
import useEtiketSil from "app/popleads/hooks/useEtiketSil";
import Card, { StyledImageBox } from "app/popleads/components/ui-kit/Card";
import { StyledCardFooter, StyledCardHeader } from "./common/styled";
import EmptyStatus from "app/popleads/components/ui-kit/EmptyStatus";
import ButtonWithLabel from "app/popleads/components/ui-kit/ButtonWithLabel";
import { colors } from "app/popleads/components/ui-kit/colors";
import ExtensionCampaignSearchInput from "./ExtensionCampaignSearchInput";
import { nameTag } from "app/popleads/app/functions/util";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Spinner from "app/popleads/components/ui-kit/Spinner";
import { StyledNameTag } from "./ExtensionViewDeal";
import { toast } from "react-toastify";
import Modal from "app/popleads/components/ui-kit/Modal";
import { StyledCampaignLinkContent } from "./ExtensionCourseCard";
import { useSelector } from "react-redux";

const CoursesContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 8px 12px;
`;

const StyledHeaderContainer = styled.div`
    display: flex;
    gap: 8px;
    width: 100%;
`;

const StyledPublicTag = styled.span`
    font-weight: 500;
    white-space: nowrap;
`;

const StyledFooterContainer = styled.div`
    display: flex;
    gap: 8px;
`;
const TruncatedText = styled.div`
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
const StyledType = styled.span`
    font-weight: 500;
    color: ${colors.neutral[800]};
`;
const StyledCountryName = styled(TruncatedText)`
    flex: 1;
`;

const ExtensionCoursesPage = () => {
    const { profile } = useExtensionContext();
    const { etiketEkle, etiketEkleLoading } = useEtiketEkle();
    const { etiketSil, setEtiketSilLoading } = useEtiketSil();
    const [showCampaignSearch, setShowCampaignSearch] = useState(false);
    const [etiketToDelete, setEtiketToDelete] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const handleInputChange = (value) => {
        // setSelectedCampaign(value);
    };
    const [errorIndexes, setErrorIndexes] = useState([]);
    const handleImageError = (index) => {
        setErrorIndexes((prev) => [...prev, index]);
    };

    const handleDeleteClick = (etiketId) => {
        setEtiketToDelete(etiketId);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
        if (isDeleting) return;

        setIsDeleting(true);
        try {
            const response = await etiketSil({
                profil: profile?.id,
                etiket: etiketToDelete,
            });

            if (response.success) {
                toast.success("Campaign deleted successfully");
            } else {
            }
        } catch (error) {
        } finally {
            setShowDeleteModal(false);
            setEtiketToDelete(null);
            setIsDeleting(false);
        }
    };
    const user = useSelector((state) => state.auth.user);

    const courseList = profile?.etiket.map((etiket, index) => {
        const cityAndCountry =
            etiket.campaignCityName && etiket.campaignCountryName
                ? etiket.campaignCityName + ", " + etiket.campaignCountryName
                : etiket.campaignCityName || etiket.campaignCountryName;
        return {
            id: etiket.id,
            customImage:
                !etiket?.courseImage || errorIndexes.includes(index) ? (
                    <StyledNameTag>{nameTag(etiket?.metin)}</StyledNameTag>
                ) : (
                    <StyledImageBox
                        onError={() => handleImageError(index)}
                        alt={etiket?.courseImage}
                        src={etiket?.courseImage}
                    />
                ),

            header: (
                <StyledCardHeader>
                    <StyledHeaderContainer>
                        <StyledPublicTag>{etiket?.campaignType}</StyledPublicTag>
                        {etiket?.campaignType && etiket?.courseName && <span>|</span>}
                        <OverlayTrigger placement="top" overlay={<Tooltip>{etiket?.courseName}</Tooltip>}>
                            <TruncatedText>{etiket?.courseName}</TruncatedText>
                        </OverlayTrigger>
                    </StyledHeaderContainer>
                </StyledCardHeader>
            ),

            content: (
                <a
                    href={user?.company?.companyConfig?.oldCrmPopleadsHttpLink + "/?campaignId=" + etiket?.campaignId}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <StyledCampaignLinkContent>{etiket.metin}</StyledCampaignLinkContent>
                </a>
            ),

            footer: (
                <StyledCardFooter>
                    <StyledFooterContainer>
                        <StyledType>{etiket.campaignDate}</StyledType>
                        {etiket.campaignCityName !== "LVT" && etiket.campaignCountryName !== "LVT" && (
                            <>
                                {etiket.campaignDate && cityAndCountry && <span>|</span>}
                                <OverlayTrigger placement="top" overlay={<Tooltip>{cityAndCountry}</Tooltip>}>
                                    <StyledCountryName>{cityAndCountry}</StyledCountryName>
                                </OverlayTrigger>
                            </>
                        )}
                    </StyledFooterContainer>
                </StyledCardFooter>
            ),

            onDelete: () => handleDeleteClick(etiket.id),
        };
    });

    const toggleSearchCampaign = () => {
        setShowCampaignSearch(!showCampaignSearch);
    };

    return (
        <CoursesContainer>
            {(setEtiketSilLoading || etiketEkleLoading) && (
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(255, 255, 255, 0.7)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1,
                    }}
                >
                    <Spinner size={32} thickness={4} variant="l3rnTech" />
                </div>
            )}
            <div style={{ marginTop: "8px", marginBottom: "16px" }}>
                <ButtonWithLabel
                    buttonStyle="default"
                    size="circle"
                    icon={showCampaignSearch ? "remove" : "add"}
                    iconType={"material"}
                    label={showCampaignSearch ? "Close Search Campaign" : "Assign New Campaign"}
                    onClick={toggleSearchCampaign}
                    variant={"l3rnTech"}
                />
            </div>

            {showCampaignSearch && (
                <div style={{ marginBottom: "16px" }}>
                    <ExtensionCampaignSearchInput
                        label={false}
                        optionClick={(value) => {
                            handleInputChange(value);
                            etiketEkle({ profil: profile?.id, etiket: value?.id });
                        }}
                    />
                </div>
            )}

            {courseList.length > 0 ? (
                courseList.map((course) => (
                    <Card
                        key={course.id}
                        cardItems={[course]}
                        variant={"courses-card"}
                        haveViewMore={false}
                        showDelete={true}
                    />
                ))
            ) : (
                <EmptyStatus description="There is no assigned campaign." />
            )}

            <Modal
                isOpen={showDeleteModal}
                onClose={() => {
                    if (!isDeleting) {
                        setShowDeleteModal(false);
                        setEtiketToDelete(null);
                    }
                }}
                title="Are you sure you want to delete this campaign?"
                variant="danger"
                icon="delete"
                successButtonText={isDeleting ? "Deleting..." : "Yes, Delete"}
                cancelButtonText="Not Now"
                onSuccess={isDeleting ? null : handleDeleteConfirm}
            >
                <div>This action cannot be undone.</div>
            </Modal>
        </CoursesContainer>
    );
};

export default ExtensionCoursesPage;
